import { BaseDocument } from './base-document';

export const communicationOperationsTypes = [
  'AZFUND_GIORNALIERE',
  'PREVIDENZA_GIORNALIERE',
  'CONFERMA_OPERAZIONE_AZFUND_SEMESTRALE',
  'CONFERME_GIORNALIERE_FONDI',
  'CONFERMA_FONDO_AZSUSTAINABLE_FUTURE',
  'CONFERME_NUOVE_GESTIONI_PATRIMONIALI',
  'CASE_TERZE_GIORNALIERE',
  'CONFERMA_ORDINE_BOLLO_MONTI',
  'CORPORATE_ACTION_RTO',
] as const;

export const communicationCategories = [
  'INFORMATIVE',
  'CONFERMA_OPERAZIONI',
  'LETTERE',
] as const

export const communicationDividendsTypes = [
  'LETTERA_DIVIDENDI',
  'CONFERMA_REINVESTIMENTO_DIVIDENDI',
  'DISTRIBUZIONE_DIVIDENDI',
  'DISTRIBUZIONE_PROVENTI',
  'DISTRIBUZIONE_PROVENTI_GALAXY',
] as const;

export const communicationReportsTypes = [
  'POSIZIONE_RIEPILOGATIVA',
  'GEST_PATRIMONIALI',
  'GEST_PATRIMONIALI_EXPOST',
  'GEST_PATRIMONIALI_EXPOST_CONTI_CHIUSI',
  'MAX',
  'MAX_FUND',
  'MAX_OMNIBUS',
  'MAX_EX_POST',
  'RTO',
  'RTO_OMNIBUS',
  'RTO_CHIUSI',
  'RTO_EXPOST',
  'RTO_EXPOST_CONTI_CHIUSI',
  'REPORT_CONSULENZA_ASSICURATIVA',
  'RENDICONTO_COSTI_EXPOST_BASE',
  'RENDICONTO_PIR',
  'RENDICONTO_CDL',
  'GEST_PATRIMONIALI_CARTACEI',
  'AZFUND_IRLANDESI',
  'RENDICONTO_NGA',
  'RENDICONTO_NGA_SMART',
  'RENDICONTO_PIR_ALTERNATIVE',
  'RENDICONTO_BOLLO_MONTI_CHIUSURA',
  'RENDICONTO_EX_POST_GP',
  'RENDICONTO_EX_POST_RTO',
  'RENDICONTO_EX_POST_MAX',
  'RENDICONTO_EX_POST_BASE',
  'MAX_FUND_EX_POST',
  'POSIZIONI_ANIMA_SGR',
  'CONSULENZA_BASE_EXPOST',
  'GPM_NUOVE_LINEE',
] as const;

export const communicationOtherLettersTypes = [
  'PERDITE_MIFID_AMMINISTRATO',
  'PERDITE_MIFID_GESTIONI',
  'NOTE_INFORMATIVE',
  'CASE_TERZE_COMUNICAZIONI_AZIONISTI',
  'LETTERA_RIMBORSO_FIA_CAPITALE_ALI',
  'LETTERA_RIMBORSO_FIA_CAPITALE_ACM',
  'LETTERA_RIMBORSO_FIA_PROVENTO_ALI',
  'LETTERA_RIMBORSO_FIA_PROVENTO_ACM',
  'LETTERA_RIMBORSO_PROVENTO_ALI',
  'LETTERA_RIMBORSO_PROVENTO_ACM',
  'LETTERA_RICHIAMO_FIA_PROD_PIR_DESC_ACM',
  'LETTERA_RICHIAMO_FIA_PROD_PIR_DESC_ALI',
  'LETTERA_RICHIAMO_FIA_PROD_NON_PIR_DESC_ALI',
  'LETTERA_RICHIAMO_FIA_PROD_NON_PIR_DESC_ACM',
  'LETTERA_RICHIAMO_FIA_PRODOTTO_NON_PIR_ALI',
  'LETTERA_RICHIAMO_FIA_PRODOTTO_NON_PIR_ACM',
  'LETTERA_RICHIAMO_FIA_PRODOTTO_PIR_ALI',
  'LETTERA_RICHIAMO_FIA_PRODOTTO_PIR_ACM',
  'LETTERA_RICHIAMO_FIA_MULTIRICHIAMO_ALI',
  'LETTERA_RICHIAMO_FIA_MULTIRICHIAMO_ACM',
  'LETTERA_CONFERMA_FIA_PAGAMENTO_ACM',
  'LETTERA_CONFERMA_FIA_PAGAMENTO_ALI',
  'LETTERA_CONFERMA_FIA_INVESTIMENTO_COMMISSIONI_ALI',
  'LETTERA_CONFERMA_FIA_INVESTIMENTO_COMMISSIONI_ACM',
  'LETTERA_CONFERMA_FIA_INVESTIMENTO_SENZA_COMMISSIONI_ACM',
  'LETTERA_CONFERMA_FIA_INVESTIMENTO_SENZA_COMMISSIONI_ALI',
  'LETTERA_CONFERMA_FIA_RICEZIONE_VERSAMENTO_ALI',
  'LETTERA_CONFERMA_FIA_RICEZIONE_VERSAMENTO_ACM',
  'LETTERA_FIA_CERTIFICAZIONE_MINUSVALENZE_ALI',
  'LETTERA_FIA_CERTIFICAZIONE_MINUSVALENZE_ACM',
  'LETTERA_TRASFERIMENTO_FIA_EREDI_ACM',
  'LETTERA_TRASFERIMENTO_FIA_EREDI_ALI',
  'LETTERA_TRASFERIMENTO_FIA_QUOTE_CESSIONARIO_ALI',
  'LETTERA_TRASFERIMENTO_FIA_QUOTE_CESSIONARIO_ACM',
  'LETTERA_TRASFERIMENTO_FIA_QUOTE_CEDENTE_ACM',
  'LETTERA_TRASFERIMENTO_FIA_QUOTE_CEDENTE_ALI',
  'LETTERA_FIA_RICHIESTA_FISCALITA_BOLLO_MONTI_ALI',
  'LETTERA_FIA_RICHIESTA_FISCALITA_BOLLO_MONTI_ACM',
  'LETTERA_FIA_PAGAMENTO_FISCALITA_PIR_ALI',
  'LETTERA_FIA_PAGAMENTO_FISCALITA_PIR_ACM',
  'LETTERA_ISTRUZIONE_PROVENTO_RTO',
  'LETTERA_ISTRUZIONE_PROVENTO_EY',
  'LETTERA_ISTRUZIONE_PIR_ALTERNATIVE',
  'LETTERA_INDIVIDUALE_GESTIONI_TOP_TEN',
  'LETTERA_INDIVIDUALE_GESTIONI_ETF',
  'LETTERA_GESTIONI',
  'LETTERA_GESTIONI_OMNIBUS',
  'LETTERA_CON_ALLEGATO',
  'LETTERA_AZIMUT_INVESTMENTS_OPHELIA',
  'COMUNICAZIONE_INFORMATIVA_DEPOSITO_PIR',
  'COMUNICAZIONE_INFORMATIVA_PIR_BOX',
  'COMUNICAZIONE_AVVIO_SERVIZIO_CONSULENZA',
  'COMUNICAZIONE_PIANI_RISPARMIO_PIR',
  'AVVISO_AZ_GLOBAL_PRIVATE_DEBT_EVERGREEN_RAIF',
  'VARIAZIONE_OFFERTA_FONDI',
  'VARIAZIONE_UNILATERALE',
  'LETTERA_ADV_SCADUTA_CLIENTI_CF_REALI',
  'LETTERA_ADV_SCADUTA_CLIENTI_CF_TECNICI',
  'LETTERA_ADV_IN_SCADENZA',
  ...communicationReportsTypes,
] as const;

export const communicationBenefitsTypes = [
  'LETTERA_BENVENUTO_AFI_ADDENDUM',
  'LETTERA_BENVENUTO_MAX',
  'LETTERA_BENVENUTO_MONO_MAX',
  'LETTERA_BENVENUTO_PIR',
  'LETTERA_BENVENUTO_AFI',
  'LETTERA_BENVENUTO_SGR',
  'LETTERA_BENVENUTO_GOAL_BASED_PLAN',
  'LETTERA_BENVENUTO_NGA',
  'LETTERA_BENVENUTO_MONO_NGA_FULL',
  'LETTERA_BENVENUTO_NGA_SMART',
  'LETTERA_BENVENUTO_MONO_NGA_SMART',
] as const;

export type CommunicationOperationsType =
  typeof communicationOperationsTypes[number];
// | 'DailyAZFUND' //AZFUND giornaliere
// | 'DailyBenefits' //Previdenze giornaliere
// | 'SemiannualAZFUNDOperationConfirmation' //Conferma operazione AZFUND semestrale
// | 'DailyFundConfirmations' //Conferme giornaliere fondi
// | 'AZSustainableFutureFundConfirmation' //Conferma Fondo AZ Sustainable Future
// | 'NewAssetManagementConfirmations'; //Conferme Nuove Gestioni Patrimoniali

export type CommunicationDividendsType =
  typeof communicationDividendsTypes[number];
// | 'DividendsLetter' //Lettera dividendi
// | 'DividendReinvestmentConfirmation'; //Conferma Reinvestimento Dividendi

export type CommunicationBenefitsType =
  typeof communicationBenefitsTypes[number];
// | 'AFIServiceWelcomeLetterAddendum' //Lettera di benvenuto Servizio AFI - Addendum
// | 'WelcomeLetterMAXService' //Lettera di benvenuto Servizio MAX
// | 'WelcomeLetterPIRService' //Lettera di benvenuto Servizio PIR
// | 'AFIWelcomeLetter' //Lettera di benvenuto AFI
// | 'WelcomeLetterSgr'; //Lettera di benvenuto Sgr

export type CommunicationOtherLettersType =
  typeof communicationOtherLettersTypes[number];
// | 'MiFIDRelevantLossesAdministered' //Perdite rilevanti MiFID - Amministrato
// | 'MiFIDRelevantLossesManagement' //Perdite rilevanti MiFID - Gestioni
// | 'InformationNotes'; //Note informative

export type CommunicationsType =
  | CommunicationOperationsType
  | CommunicationDividendsType
  | CommunicationBenefitsType
  | CommunicationOtherLettersType;

export type CommunicationsCategory =
  typeof communicationCategories[number];

export interface CommunicationsDocument
  extends BaseDocument<CommunicationsType> {
  jurisdictionDate?: Date;
}

export const communicationTypes: CommunicationsType[] = [
  ...communicationOperationsTypes,
  ...communicationDividendsTypes,
  ...communicationOtherLettersTypes,
  ...communicationBenefitsTypes,
];
